/*
 * @Author: your name
 * @Date: 2021-11-26 16:54:06
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\app.routing.ts
 */
import store from "@/store";
import { RouterView } from "vue-router";
import {
  DashboardRouting,
  PosterRouting,
  InformationRouting,
} from "@/views/dashboard/dashboard.routing";
import { LoginRouting } from "@/views/login/login.routing";
import { Login2Routing } from "@/views/login2/login.routing";
import { ErrorRouting } from "@/views/error/error.routing";
import { ProjectRouting } from "@/views/project/project.routing";
import { TenderRouting } from "@/views/tender/tender.routing";
import { DebugRouting } from "@/views/debug/debug.routing";
import { ContractRouting } from "@/views/contract/contract.routing";
import { OrganizationRouting } from "@/views/organization/organization.routing";
import { CooperationRouting } from "@/views/cooperation/cooperation.routing";
import { MaterialRouting } from "@/views/material/material.routing";
import { PurchaseRouting } from "@/views/purchase/purchase.routing";
import { ProjectConfigRouting } from "@/views/project-config/project-config.routing";
import { FinanceRouting } from "@/views/finance/finance.routing";
// import { SystemRouting } from "@/views/system/system.routing";
import { WorkManageRouting } from "@/views/work-manage/work-manage.routing";
import { QualityRouting } from "@/views/quality/quality.routing";
// import { TenantRouting } from "@/views/tenant/tenant.routing";
import { SafetyRouting } from "@/views/safety/safety.routing";
import { JoinRouting } from "@/views/join/join.routing";
import { JoinH5Routing } from "@/views/join/h5/welcome/routing";
import { MobileCodeRouting } from "@/views/join/h5/mobile-code/routing";
import { SetPasswordRouting } from "@/views/join/h5/set-password/routing";
import { ErrorPageRouting } from "@/views/join/h5/error-page/routing";
import { SuccessPageRouting } from "@/views/join/h5/success-page/routing";
import { FilePreviewRouting } from "@/views/join/h5/file-preview/routing";
import { InspectionPageRouting } from "@/views/join/h5/inspection-page/routing";
import { InspectionDetailRouting } from "@/views/join/h5/inspection-detail/routing";
import { ClubRouting } from "@/views/join/h5/club/club.routing";

import { ProcessManageRouting } from "@/views/process-manage/process-manage.routing";
import { ProcessCenterRouting } from "@/views/process-center/process-center.routing";
import { PersonalWorkbenchRouting } from "@/views/personal-workbench/personal-workbench.routing";
import { LeaseConfigRouting } from "@/views/lease-config/lease-config.routing";
import { TicketRouting } from "@/views/ticket/ticket.routing";
import { ProjectPaymentRouting } from "@/views/project-payment/projectPayment.routing";
import { SubcontractManagementRouting } from "@/views/subcontract-management/subcontract-management.routing";
import { AssetManageRouting } from "@/views/asset-management/assetManag.routing";
import { SealManageRouting } from "@/views/seal-management/sealManage.routing";
import { staffManageRouter } from "@/views/staff-manage/staff-manage.router";
import { MessageCenterRouting } from "@/views/message-center/message-center.routing";
import { DataDictRouting } from "@/views/data-dict/data-dict.routing";
import { FinishedProjectManageRouting } from "@/views/finished-project/finished-project.routing";
import { InformationManageRouting } from "./views/information-manage/information-manage.routing";
import { IndexManageRouting } from "./views/index-manage/index-manage.routing";
import { AttendanceRouting } from "@/views/attendance-management/attendance-management.routing";
import { LicenseManageRouting } from "./views/license-manage/license-manage.routing";
import { AppStoreRouting } from "@/views/app-store/app-store.routing";
import { QuoteRouting } from "./views/quote/quote.routing";

import { ListRouting } from "@/views/dashboard/list/list.routing";
import { DishabledDetialRouting } from "@/views/dashboard/detail/detail.routing";
import { RiskConfigRouting } from "@/views/risk-config/risk-config.routing";
import { ReportCenterRouting } from "@/views/report-center/report-center.routing";
import { DataboardRouting } from "@/views/data-board/data-board.routing";
import { MaterialBaseRouting } from "@/views/material/otherMaterial.routing";
import { TrialRouting } from "@/views/Invite-trial/Invite-trial.routing";
import { NoAccessRouting } from "@/views/error/error.routing";
import { VersionRouting } from "@/views/version/version.routing";
import { UserInfoRouting } from "@/views/user-info/user-info.routing";
import { CompanySettionRouting } from "@/views/companySetting/companySettion.routing";
import { InspectionRouting } from "@/views/inspection-management/inspection-management.routing";
import { NoviceGuideRouting } from "@/views/novice-guide/novice-guide.routing";
import { VersionDetailRouting } from "@/views/versionDetail/versionDetail.routing";
import {
  VersionDetailH5Routing,
  MiniatureVersionDetailH5Routing,
} from "@/views/join/h5/version-detail/version-detail-routing";
import CloudDiskRouting from "@/views/cloud-disk/cloud-disk.routing";
import { LaborRouting } from "@/views/labor/labor.routing";
//保修管理
import { WarrantyRouting } from "@/views/warranty/warranty.routing";
//电子签
import { signaturesRouter } from "@/views/signatures/signatures.routing";
import { SignLink } from "@/views/signatures/customer-management/sign-link/sign-link-routing";
import { VideoIntroducePageRouting } from "@/views/VideoIntroducePage/VideoIntroducePage.routing";
import { MaintenanceSettingRouting } from "./views/maintenance/maintenanceSetting.routing";
import { MaintenanceRouting } from "./views/maintenance/maintenance.routing";
import { MaintenanceAcceptanceRouting } from "./views/join/h5/maintenance-acceptance/maintenance-acceptance-routing";
import { CalcRouting } from "./views/calc/calc.routing";

// 电子签平台
import { WorkbenchRouting } from "./views/platform-electronic-visa/workbench/index.routing";
import { ExpenseRouting } from "./views/expense/expense.routing";
// 绑定河姆渡账号
import { BindHmdAccountRouting } from "./views/bind-hmd-account/index.routing";
import { ContractArchiveRouting } from "./views/contract-archive/contract-archive.routing";
import { SignatureRouting, SignatureLink } from "./views/platform-electronic-visa/signature/index.routing";
import { PopularizeLink } from "./views/platform-electronic-visa/popularizeLink/index.routing";


const NotFoundRouting = {
  path: "/:pathMatch(.*)*",
  name: "not-found",
  // redirect: "/error/404",
  component: () => import(/* webpackChunkName: "404" */ "@/views/error/404.vue"),
};

const RedirectRouting = {
  hidden: true,
  path: "/redirect/:path*",
  name: "redirect",
  component: RouterView,
  meta: { title: "重定向" },
  children: [
    {
      hidden: true,
      path: "",
      name: "redirect",
      component: () => import("@/views/redirect/index.vue"),
      meta: { keepAlive: false },
    },
  ],
};
export const AppRouting = [
  // DashboardRouting,
  {
    path: "/",
    name: "home",
    title: "工作台",
    redirect: (to) => {
      const belongSystem = store.state.user.belongSystem;
      const path =
        belongSystem == 2
          ? { path: "/platform-electronic-visa/workbench" }
          : { path: "/dashboard" };
      return path;
    },
    component: () => import("@/views/home/index.vue"),
    children: [
      ...TenderRouting.children,
      ...ContractRouting.children,
      ...ProjectRouting.children,
      ...DataboardRouting.children,
      ...ReportCenterRouting.children,
      ...RiskConfigRouting.children,
      ...RiskConfigRouting.children,
      ...WorkManageRouting.children,
      ...MaterialRouting.children,
      ...PurchaseRouting.children,
      ...SubcontractManagementRouting.children,
      ...LeaseConfigRouting.children,
      ...QualityRouting.children,
      ...SafetyRouting.children,
      ...TicketRouting.children,
      ...ProjectPaymentRouting.children,
      ...FinishedProjectManageRouting.children,
      //行政
      ...InformationManageRouting.children,
      ...LicenseManageRouting.children,
      ...AssetManageRouting.children,
      ...SealManageRouting.children,
      // 人事
      ...staffManageRouter.children,
      ...AttendanceRouting.children,
      // 基础资料
      ...OrganizationRouting.children,
      ...CooperationRouting.children,
      ...MaterialBaseRouting.children,
      ...MaintenanceSettingRouting.children,
      ...MaintenanceRouting.children,
      ...ProjectConfigRouting.children,
      ...FinanceRouting.children,
      ...ProcessManageRouting.children,
      ...DataDictRouting.children,
      ...InspectionRouting.children,
      //保修管理
      ...WarrantyRouting.children,
      ...NoviceGuideRouting.children,
      //劳务管理
      ...LaborRouting.children,
      DebugRouting,
      DashboardRouting,
      InformationRouting,
      PosterRouting,
      PersonalWorkbenchRouting,
      ProcessCenterRouting,
      MessageCenterRouting,
      ...ListRouting,
      ...DishabledDetialRouting,
      NoAccessRouting,
      VersionRouting,
      UserInfoRouting,
      CalcRouting,
      ...CompanySettionRouting,
      // 云盘
      //电子签
      // ...signaturesRouter.children,
      ...CloudDiskRouting,
      // ...signaturesRouter.children,
      ...AppStoreRouting.children,
      ...QuoteRouting.children,
      ...ExpenseRouting.children,
      ...ContractArchiveRouting.children,
    ],
  },
  {
    path: "/platform-electronic-visa",
    name: "homeElectronicVisa",
    title: "工作台",
    redirect: "/workbench",
    component: () => import("@/views/home/index.vue"),
    children: [...WorkbenchRouting, ...SignatureRouting],
  },
  JoinRouting,
  JoinH5Routing,
  LoginRouting,
  Login2Routing,
  MobileCodeRouting,
  MaintenanceAcceptanceRouting,
  VersionDetailH5Routing,
  MiniatureVersionDetailH5Routing,
  SetPasswordRouting,
  ErrorPageRouting,
  SuccessPageRouting,
  FilePreviewRouting,
  InspectionPageRouting,
  InspectionDetailRouting,
  ClubRouting,
  ErrorRouting,
  NotFoundRouting,
  RedirectRouting,
  TrialRouting,
  // ...VersionDetailRouting,
  // SignLink,
  // ...VersionDetailRouting,
  // SignLink,
  VideoIntroducePageRouting,
  BindHmdAccountRouting,
  ...SignatureLink,
  ...PopularizeLink,
];
